import React, { useState, useEffect, Fragment } from "react";
import * as yup from "yup";
import { Report, TonnageDisclaimer } from "../../../shared";
import { useHistory, useParams, useLocation } from "react-router-dom";
import queryString from "query-string";

const schema = yup.object().shape(
  {
    fromDate: yup.string().required("Ship From Date is required."),
    toDate: yup.string().required("Ship To Date is required."),
    city: yup.string().when(["county"], {
      is: (county) => !county,
      then: yup.string().required("One of these fields is required."),
    }),
    county: yup.string().when(["city"], {
      is: (city) => !city,
      then: yup.string().required("One of these fields is required."),
    }),
  },
  [
    ["county", "city"],
    ["city", "county"],
  ]
);

export default function ExportCupaDataToCsv() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [initialFormValues, setInitialFormValues] = useState({
    fromDate: params && params.fromDate ? params.fromDate : "",
    toDate: params && params.toDate ? params.toDate : "",
    county: "",
    city: "",
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState("Generator Waste Summary by Region");
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/cupareport/year"
  );

  const formConfig = [
    {
      name: "fromDate",
      config: {
        col: "md",
        colWidth: "3",
        label: "Ship From Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "toDate",
      config: {
        col: "md",
        colWidth: "3",
        label: "Ship To Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "city",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "City",
        placeholder: "City",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/cities",
        hasApi: true,
      },
    },
    {
      name: "county",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "County",
        placeholder: "County",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/counties",
        hasApi: true,
      },
    },
  ];

  return (
    <Fragment>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: "Generator Waste Summary by Region", url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        apiEndpoint={apiEndpoint}
        searchOnInit={searchOnInit}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </Fragment>
  );
}

// export default ExportCupaDataToCsv;
